import baseRequest, { baseRequestBackendTs } from "./baseRequest"

export const getCashlessDentalRequests = (params = {}) => {
    const url = '/cashless-dental/mdp/new-ops/allRequests'
    const method = 'GET'
    return baseRequest(url, method, params, null)
}

export const getDentalRequests = (requestId) => {
    const url = `/cashless-dental/mdp/new-ops/${requestId}/details?isSecureDocumentUrl=1`;
    const method = 'GET';
    return baseRequest(url, method, null, null);
};

export const getDentalRequestComments = (requestId) => {
    console.log(requestId,'[getDentalRequestComments]')
    const url = `/cashless-dental/mdp/new-ops/get-comments/${requestId}`;
    const method = 'GET';
    return baseRequest(url, method, null, null);
};

export const addCommentToRequest = (requestId, comment) => {
    const url = `/cashless-dental/mdp/new-ops/comments/${requestId}`;
    const method = 'POST';
    const data = {comment}
    return baseRequest(url, method, null, data);
};

export const getProcedures = (requestId) => {
    const url = `/cashless-dental/mdp/new-ops/get-procedures/${requestId}`;
    const method = 'GET';
    return baseRequest(url, method, null, null);
};

export const addProcedureRequest = (requestId, procedureId, procedureFee) => {
    const url = `/cashless-dental/mdp/new-ops/add-procedure-request`;
    const method = 'POST';
    const data = {requestId, procedureId, procedureFee}
    return baseRequest(url, method, null, data);
};

export const deductWalletBalance = (requestId, procedureAmount, requestProcedureId, procedureId) => {
    const url = `/cashless-dental/mdp/new-ops/wallet-deduction`;
    const method = 'POST';
    const data = {requestId, procedureAmount, requestProcedureId, procedureId}
    return baseRequest(url, method, null, data);
};

export const callPatient = (requestId) => {
    const url = `/cashless-dental/mdp/new-ops/${requestId}/call/user`;
    const method = 'POST';
    return baseRequest(url, method, null, null);
};

export const markProcedureRemoved = (requestId, requestProcedureId) => {
    const url = `/cashless-dental/mdp/new-ops/mark-procedure-removed`;
    const method = 'POST';
    const data =  {requestId, requestProcedureId};
    return baseRequest(url, method, null, data);
}

export const uploadPrescription = (formData) => {
    const url = `/cashless-dental/mdp/new-ops/users/upload-prescription`;
    const method = 'POST';
    const data = formData;
    return baseRequest(url, method, null, data);
};

export const getDentalHistory = (requestId) => {
    const url = `/cashless-dental/mdp/new-ops/request-history/${requestId}`;
    const method = 'GET';
    return baseRequest(url, method, null, null);
};

export const cancelDentalModal = (requestId, reason) => {
    const url = `/cashless-dental/mdp/new-ops/cancel-ops-appointment`;
    const method = 'POST';
    const data = {
        reason,
        requestId
    }
    return baseRequest(url, method, null, data);
};

export const refundProcedureAmount = (requestId, procedureRequestsId) => {
    const url = `/cashless-dental/mdp/new-ops/refund-procedure`;
    const method = 'POST';
    const data = {
        requestId, procedureRequestsId
    }
    return baseRequest(url, method, null, data);
};

export const markAppointmentComplete = (requestId) => {
    const url = `/cashless-dental/mdp/new-ops/mark-appointment-complete`;
    const method = 'POST';
    const data = {
        requestId
    }
    return baseRequest(url, method, null, data);
};

export const claimDentalRequest = (requestId) => {
    const url = `/cashless-dental/mdp/new-ops/ops-request-claim/${requestId}`;
    const method = 'POST';
    return baseRequest(url, method, null, null);
};

export const confirmAppointmentAPI = (requestId, requestType) => {
    const url = `/cashless-dental/mdp/new-ops/confirm-appointment`;
    const method = 'POST';
     const data = {
        requestId,
        requestType
    }
    return baseRequest(url, method, null, data);
};

// backend ts
export const rescheduleAppointment = (data) => {
    const url = `/cashless-dental/ops/reschedule-appointment`;
    const method = 'POST';
    return baseRequestBackendTs(url, method, null, data);
};

export const getTimeSlots = () => {
    console.log('getTimeSlots')
    const url = `/cashless-dental/ops/get-date-slots`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, null, null);
};